module.exports = __webpack_public_path__ + "img/87-Krische Piemont - Merisier.jpg";